export enum AffiliateMailType {
  EXTRACT_WARNING_LOW = 'EXTRACT_WARNING_LOW',
  EXTRACT_WARNING_HIGH = 'EXTRACT_WARNING_HIGH',
  ACTIVATION_NOUVEAU_MEDIA = 'ACTIVATION_NOUVEAU_MEDIA',
}

export enum CandidateMailType {
  REJECTED_APPLICATION = 'REJECTED_APPLICATION',
}